import { Pencil } from "lucide-react";
import { Avatar, AvatarFallback } from "@/components/ui/library/avatar";
import { getInitials } from "@/utils/convetors";
import ActivityTimestamp from "./ActivityTimestamp";

interface UpdateActivityProps {
  activity: any;
  isLast: boolean;
}

export default function UpdateActivity({
  activity,
  isLast,
}: UpdateActivityProps) {
  const user = activity.user ?? {};


  return (
    <div className="flex gap-4 items-start relative w-full">
      <div className="flex flex-col items-center relative self-stretch shrink-0">
        <div className="bg-white border border-[#e6e8e7] flex items-center justify-center p-2 relative rounded-[12px] shadow-[0px_4px_9px_0px_rgba(0,0,0,0.07)] shrink-0 size-[36px]">
          <Pencil className="size-4 text-[#654aff]" strokeWidth={2} />
        </div>
        {!isLast && (
          <div className="flex-1 min-h-[32px] w-0 relative shrink-0">
            <div className="absolute inset-0 border-l border-[#e6e8e7] border-dashed" />
          </div>
        )}
      </div>

      <div
        className={`flex-1 flex flex-col items-start justify-center min-h-0 ${
          isLast ? "pb-0" : "pb-8"
        } pt-[9px] px-0 relative min-w-0`}
      >
        <div className="flex items-start justify-between leading-normal relative shrink-0 w-full mb-0">
          <p className="text-[14px] font-medium text-black tracking-[-0.56px] leading-[1.35] flex-1 min-w-0 break-words [overflow-wrap:anywhere]">
            <span className="text-[#654aff]">{user.name ?? "System"}</span>{" "}
            <span className="text-[#697571]">
              {activity.content || activity.actionType}
            </span>
          </p>
          <ActivityTimestamp createdAt={activity.createdAt} />
        </div>

        <div className="flex gap-1 items-center pb-0 pt-2 px-0 relative shrink-0">
          <Avatar className="size-5 shrink-0 rounded-full bg-[#e1e4ea]">
            <AvatarFallback className="text-[10px] font-medium leading-[16px] bg-[#e1e4ea] text-[#505e59]">
              {getInitials(user.name ?? "System")}
            </AvatarFallback>
          </Avatar>
          <p className="text-[12px] font-normal text-[#1e302a] tracking-[-0.24px] text-nowrap">
            {user.name ?? "System"}
          </p>
        </div>
      </div>
    </div>
  );
}
